import * as React from 'react';
import { MasterPage } from '../master-page/master.page';
import { ProsSection } from './components/ProsSection';
import { RegisterSection } from './components/RegisterSection';
import { ScreenShootSection } from './components/ScreenShootSection';
import { TitleSection } from './components/TitleSection';
import { TutorTypes } from './components/TutorTypes';
import { TypesSection } from './components/TypesSection';

const AboutUsInstitutPage: React.FC = () => (
  <MasterPage
  withAdvert
  topSection={
    <>
      <TitleSection/>
      <TutorTypes/>
      <ProsSection/>
      <TypesSection/>
      <ScreenShootSection/>
      <RegisterSection/>
    </>
  }
  />
);
export default AboutUsInstitutPage;
